import { Injectable } from '@angular/core';
import { InvestigationApproval } from '../../domain/entities/investigation-approval.entity';
import { InvestigationApprovalResponseDto } from '../dtos/investigation-approval-response.dto';

@Injectable({ providedIn: 'root' })
export class InvestigationApprovalMapper {
  toDomain(dto: InvestigationApprovalResponseDto): InvestigationApproval {
    const entity = new InvestigationApproval();
    entity.investigationId = dto.id;
    entity.investigationNumber = dto.investigationNumber;
    entity.investigationTypeName = dto.investigationTypeName;
    entity.statusName = dto.statusName;
    entity.statusDisplayName = dto.statusDisplayName;
    entity.statusColor = dto.statusColor;
    entity.priorityCode = dto.priorityCode;
    entity.dueDate = dto.dueDate ? new Date(dto.dueDate) : null;
    entity.createdOn = new Date(dto.createdOn);
    return entity;
  }

  toDomainArray(dtos: InvestigationApprovalResponseDto[]): InvestigationApproval[] {
    return dtos.map((dto) => this.toDomain(dto));
  }
}
